import { useEffect, useRef } from "react";
import { Bold, Italic, Heading2, Heading3, List, ListOrdered, Link2, Unlink, Pilcrow } from "lucide-react";

const toHtml = (v) => (!v ? "" : /<[a-z][\s\S]*>/i.test(v) ? v
  : v.split(/\n{2,}/).map((p) => `<p>${p.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\n/g, "<br>")}</p>`).join(""));

const TOOLS = [
  ["bold", Bold, "Bold", () => document.execCommand("bold")],
  ["italic", Italic, "Italic", () => document.execCommand("italic")],
  ["h2", Heading2, "Heading", () => document.execCommand("formatBlock", false, "h2")],
  ["h3", Heading3, "Sub-heading", () => document.execCommand("formatBlock", false, "h3")],
  ["p", Pilcrow, "Normal text", () => document.execCommand("formatBlock", false, "p")],
  ["ul", List, "Bullet list", () => document.execCommand("insertUnorderedList")],
  ["ol", ListOrdered, "Numbered list", () => document.execCommand("insertOrderedList")],
  ["link", Link2, "Add link", () => {
    let url = (window.prompt("Link address (e.g. /help/returns or https://…)") || "").trim();
    if (!url) return;
    if (/^www\./i.test(url)) url = `https://${url}`;
    if (/^(\/|https?:\/\/|mailto:|tel:)/i.test(url)) document.execCommand("createLink", false, url);
    else window.alert("Links must start with /, https://, mailto: or tel:");
  }],
  ["unlink", Unlink, "Remove link", () => document.execCommand("unlink")],
];

export function RichTextEditor({ value, onChange, testid }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && document.activeElement !== ref.current) ref.current.innerHTML = toHtml(value);
  }, [value]);
  const emit = () => onChange(ref.current.innerHTML);
  return (
    <div className="rounded-md border bg-white" data-testid={testid}>
      <div className="flex flex-wrap gap-0.5 border-b p-1 bg-slate-50 rounded-t-md">
        {TOOLS.map(([k, Icon, title, run]) => (
          <button key={k} type="button" title={title} aria-label={title} data-testid={`${testid}-tool-${k}`}
            onMouseDown={(e) => { e.preventDefault(); ref.current.focus(); run(); emit(); }}
            className="p-1.5 rounded hover:bg-white hover:text-accent transition-colors"><Icon size={15} /></button>))}
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={emit} onBlur={emit}
        className="cms-body min-h-[160px] max-h-[420px] overflow-y-auto p-3 text-sm focus:outline-none" data-testid={`${testid}-area`} />
    </div>
  );
}
